module.exports = __webpack_public_path__ + "static/apple_splash_1668-268827b7e944067af89f9065a1cf6f5f.png";